import Page from "@pages/assets/index";
export const Assets = {
	path: "/assets",
	name: "assets",
	component: Page,
	meta: {
		title: "Assets",
	}
};